import {
  Box,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
  Backdrop,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { jwtDecode } from "jwt-decode";
import TopPerformers from "../../agent/leaderboard/TopPerformers";
import TeamRanking from "../../agent/leaderboard/TeamRanking";
import CommonFilter from "../../../components/CommonFilter";
import Loader from "../../../components/AnimatedLoader";
import { palette, theme as colorTheme } from "../../../Convoze.theme";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";



function LeaderBoard() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [responseData, setResponseData] = useState();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";

  const [payloadData, setPayloadData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeaderBoardDetails();
  }, [payloadData]);

  const fetchLeaderBoardDetails = async () => {
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
    };
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.agentLeaderboard,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setResponseData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Leaderboard fetch error:", error);
      }
    }
  };

  const isCurrentAgent = responseData?.performanceLeaderborad?.find(
    (agent) => agent?.agentId === decodedToken?.agentId
  );
  const isFilter = { date: true, filter: false };

  return (
    // <Box
    //   sx={{
    //    ml: {
    //       xs: "0px",
    //       md: "230px",
    //     },
    //     p: 3,
    //     display: "flex",
    //     flexDirection: "column",
    //     gap: 2,
    //     position: "relative",
    //   }}
    // >

    <ParentWrapper>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexDirection: isMobile ? "column" : "row",
          // mb: 3,
        }}
      >
        <Box>
          {/* <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              color: "#424242",
            }}
          >
            {"LeaderBoard"}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary">
            Have comparative analysis of all your agents
          </Typography> */}
        {/* <Header title={"LeaderBoard"} subHeading={"Have comparitive analysis of all your agents"} /> */}
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignSelf: isMobile ? "flex-end" : "center",
          }}
        >
          <CommonFilter
            setPayloadData={setPayloadData}
            storageName={"ManagerleaderBoard"}
            isFilter={isFilter}
          />
        </Box>
      </Box>
      {loading ? (
        <Loader />
      ) : (
        <Grid container spacing={2.5} sx={{}}>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 12 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <TopPerformers
              leaderBoardData={responseData?.performanceLeaderborad}
            />
          </Grid>

          <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
            <TeamRanking
              leaderBoardData={responseData?.performanceLeaderborad}
              isCurrentAgent={isCurrentAgent}
            />
          </Grid>
        </Grid>
      )}
    </ParentWrapper>


    // </Box>
  );
}

export default LeaderBoard;
